import React from 'react';

export default function DeleteDialog({ open, onClose, onDelete }) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[3000] bg-black/30"
      onClick={(e) => {
        // backdrop 클릭(자식 클릭이 아닌 경우)일 때만 닫기
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        className="absolute left-1/2 top-1/2 w-[calc(100%-2rem)] max-w-md -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-white p-5 shadow-2xl"
      >
        <div className="text-center text-base font-bold text-gray-900">삭제하시겠습니까?</div>
        <div className="mt-3 text-sm leading-6 text-gray-600 text-center">
          삭제 후 되돌릴 수 없습니다. 계속 진행하시겠습니까?
        </div>

        <div className="mt-5 grid grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onClose}
            className="h-11 rounded-2xl border border-gray-300 bg-white text-sm font-bold text-gray-700 active:scale-[0.98] active:bg-gray-50"
          >
            닫기
          </button>

          <button
            type="button"
            onClick={() => {
              onDelete?.();
              onClose?.();
            }}
            className="h-11 rounded-2xl bg-red-500 text-sm font-bold text-white active:scale-[0.98] active:bg-red-600"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
  );
}
